export default "__VITE_ASSET__4ES8_4S1__"